module.exports = __webpack_public_path__ + "img/urgent.5254a070.png";